import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getPushNotificationList } from "store/reducers/common.slice";
import firebase from "firebase/compat/app";
import "firebase/compat/messaging"; // Import messaging from firebase compat
import "firebase/compat/database";
import "firebase/compat/firestore";

// Your Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyA87qUgkMZXFuiXofMPKqMJQtMeeM9QMMk",
  authDomain: "angelforex-981d9.firebaseapp.com",
  databaseURL: "https://angelforex-981d9-default-rtdb.firebaseio.com",
  projectId: "angelforex-981d9",
  storageBucket: "angelforex-981d9.firebasestorage.app",
  messagingSenderId: "1015080453106",
  appId: "1:1015080453106:web:7ba3df08f3a5b7cdf2216b",
  measurementId: "G-JM5CPWC5S7",
};

// Initialize Firebase
if (!firebase.apps.length) {
  firebase.initializeApp(firebaseConfig);
}

// Get a messaging instance
const messaging = firebase.messaging();

const NotificationApp = () => {
  const [notifications, setNotifications] = useState([]);
  const dispatch = useDispatch();
  useEffect(() => {
    // Request permission to show notifications
    Notification.requestPermission().then((permission) => {
      if (permission === "granted") {
        let savedToken = localStorage.getItem("fcmToken");
        if (!savedToken) {
          messaging
            .getToken({
              vapidKey:
                "BG7d3wcJsv29x0G1CClcNJ6Iy3ZxnCKs2vSS8CPMp_DqRlRg3zYbppQw4YXEK4iJgu3eRZaBLxxL04G9dEyG0jc",
            })
            .then((currentToken) => {
              if (currentToken) {
                localStorage.setItem("fcmToken", currentToken);
              } else {
                console.log("No registration token available. Request permission to generate one.");
              }
            })
            .catch((err) => {
              console.log("An error occurred while retrieving token. ", err);
            });
        }
      } else {
        console.log("Unable to get permission to notify.");
      }
    });

    // Handle foreground messages
    messaging.onMessage((payload) => {
      const newNotification = {
        title: payload.notification.title,
        message: payload.notification.body,
      };
      setNotifications((prev) => [...prev, newNotification]);
      dispatch(getPushNotificationList());
    });
  }, [dispatch]);
  useEffect(() => {
    // Close each notification after 10 seconds
    const timers = notifications.map((_, index) => {
      return setTimeout(() => handleClose(index), 10000); // Close after 10 seconds
    });

    // Clear timeouts on unmount or when notifications change
    return () => {
      timers.forEach((timer) => clearTimeout(timer));
    };
  }, [notifications]);
  const handleClose = (index) => {
    setNotifications((prev) => prev.filter((_, i) => i !== index)); // Remove notification
  };
  return (
    <div
      className="notification-container"
      style={{ position: "fixed", bottom: "20px", right: "20px", zIndex: 1000 }}
    >
      {notifications.map((notif, index) => (
        <div
          key={index}
          className="notification"
          style={{
            background: "#444",
            color: "#fff",
            padding: "15px",
            margin: "10px 0",
            borderRadius: "10px",
            boxShadow: "0 4px 15px rgba(0, 0, 0, 0.3)",
            animation: "slideIn 0.5s ease, fadeOut 0.5s ease 4s forwards", // Add fade out animation
            transition: "opacity 0.5s ease",
            opacity: 1,
            position: "relative",
          }}
        >
          <strong
            style={{ display: "block", marginBottom: "5px", fontSize: "16px", fontWeight: "600" }}
          >
            {notif.title}
          </strong>
          <p style={{ margin: "0", fontSize: "14px", lineHeight: "1.4" }}>{notif.message}</p>
          <span
            onClick={() => handleClose(index)}
            style={{
              position: "absolute",
              top: "10px",
              right: "10px",
              cursor: "pointer",
              fontSize: "18px",
              color: "#f00",
              transition: "transform 0.3s", // Add hover effect
            }}
            className="fas fa-times"
          ></span>
        </div>
      ))}
    </div>
  );
};

export default NotificationApp;
